<form #thisForm="ngForm" [ngClass]="{ 'card mt-3': showHeader === true }">
  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados do Favorecido</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-3">
          <div>
            <div class="form-check form-check-inline">
              <label for="isNewFavored">Novo Favorecido</label>
              <input
                data-cy="isNewFavored"
                class="form-check-input"
                id="isNewFavored"
                name="isNewFavored"
                [(ngModel)]="favoredModel.isNewFavored"
                type="checkbox"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2" *ngIf="!favoredModel.isNewFavored">
        <div class="col-4" [class.has-error]="hasError('name')">
          <label>Nome</label>
          <ng-select
            notFoundText="Favorecido não encontrado"
            typeToSearchText="Digite o nome do favorecido para pesquisar..."
            [selectOnTab]="true"
            [required]="true"
            (change)="fillComponentWhenFavoredSelected()"
            [(ngModel)]="selectedFavored"
            [ngModelOptions]="{ standalone: true }"
            [typeahead]="favoredSearchNameTerm"
            [items]="favoredByName | async"
            [clearable]="false"
            bindLabel="name"
            [disabled]="!formEnabled"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
        </div>

        <div class="col-4" [class.has-error]="hasError('document')">
          <label>CPF/CNPJ</label>
          <ng-select
            notFoundText="Favorecido não encontrado"
            typeToSearchText="Digite o CPF/CNPJ do favorecido para pesquisar..."
            [selectOnTab]="true"
            (change)="fillComponentWhenFavoredSelected()"
            [(ngModel)]="selectedFavored"
            [ngModelOptions]="{ standalone: true }"
            [typeahead]="favoredSearchDocumentTerm"
            [items]="favoredByDocument | async"
            [clearable]="false"
            bindLabel="document"
            [disabled]="!formEnabled"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.document }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
        </div>

        <div class="col-4" [class.has-error]="hasError('bank')">
          <label>Dados Bancários</label>
          <ng-select
            [readonly]="true"
            [(ngModel)]="selectedFavored"
            [ngModelOptions]="{ standalone: true }"
            [items]="favoredAccountList"
            [clearable]="false"
            [disabled]="!formEnabled"
          >
            <ng-template
              ng-label-tmp
              let-item="item"
              *ngIf="selectedFavored !== null"
            >
              Banco: {{ item.bank }}&nbsp;&nbsp;&nbsp;&nbsp;Agência:
              {{ item.branch }}&nbsp;&nbsp;&nbsp;&nbsp;Conta Corrente:
              {{ item.account }}
            </ng-template>
            <ng-template ng-header-tmp *ngIf="favoredAccountList !== null">
              <div class="row mb-2">
                <div class="col-4">Banco</div>
                <div class="col-4">Agência</div>
                <div class="col-4">Conta</div>
              </div>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="row mb-2">
                <div class="col-4">{{ item.bank }}</div>
                <div class="col-4">{{ item.branch }}</div>
                <div class="col-4">{{ item.account }}</div>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div *ngIf="favoredModel.isNewFavored" class="row mb-2">
        <div class="col-6" [class.has-error]="hasError('name')">
          <label>Nome</label>
          <input
            data-cy="favoredName"
            type="text"
            class="form-control"
            name="favoredName"
            [(ngModel)]="favoredModel.name"
            maxlength="90"
            pattern="^(?!\s*$).+"
            required
          />
        </div>
        <div class="col-6" [class.has-error]="hasError('document')">
          <label>CPF/CNPJ</label>
          <input
            data-cy="favoredDocument"
            type="text"
            class="form-control"
            name="favoredDocument"
            [(ngModel)]="favoredModel.document"
          />
        </div>
      </div>

      <div class="row mb-2" *ngIf="favoredModel.isNewFavored">
        <div class="col-4" [class.has-error]="hasError('bank')">
          <label>Banco</label>
          <app-select-bank
            #bankComponent
            name="fundBank"
            [banks]="banksList"
            [(selectedBankId)]="favoredModel.bank"
            [readOnly]="!edit()"
          ></app-select-bank>
        </div>
        <div class="col-3" [class.has-error]="hasError('branch')">
          <label>Agência (Sem Dígito)</label>
          <input
            data-cy="fundBranch"
            type="text"
            class="form-control"
            name="fundBranch"
            [(ngModel)]="favoredModel.branch"
            pattern="\w+-?\w*"
            maxlength="4"
            mask="0000"
          />
        </div>
        <div class="col-5" [class.has-error]="hasError('account')">
          <label>Conta</label>
          <input
            data-cy="fundAccount"
            type="text"
            class="form-control"
            name="fundAccount"
            [(ngModel)]="favoredModel.account"
            pattern="\w+-?\w*"
            maxlength="15"
          />
        </div>
      </div>
    </div>
  </div>
</form>
